// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.9996 9.04019L7.61829 7.13818L6.63776 8.88133L8.45877 9.90565L6.59961 11.3L7.79961 12.9L10.9996 10.5L10.9996 9.04019ZM15.5404 9.90565L17.3614 8.88133L16.3809 7.13818L12.9996 9.04019L12.9996 10.5L16.1996 12.9L17.3996 11.3L15.5404 9.90565ZM11.9996 19C14.761 19 16.9996 16.7614 16.9996 14H6.9996C6.9996 16.7614 9.23818 19 11.9996 19Z"}}]};

const JoyfulFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'joyful-filled',
    ref,
    icon: element,
  },
));

JoyfulFilledIcon.displayName = 'JoyfulFilledIcon';

export default JoyfulFilledIcon;
